import { render } from "./FinalExamRuleView.vue?vue&type=template&id=3a1c2c46"
import script from "./FinalExamRuleView.vue?vue&type=script&lang=js"
export * from "./FinalExamRuleView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__